import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import { Capacity } from "../models"
import queryKeys from "../queryKeys"

export interface useCapacitiesOptions {
  capacityGroupIds: string[]
}

const useCapacities = (options: useCapacitiesOptions) => {
  return useQuery<Capacity[]>({
    queryKey: queryKeys.capacities({
      capacityGroupIds: options.capacityGroupIds,
    }),
    queryFn: async () => {
      const body = {
        ...options,
      }
      const res = await bffApi.post<{ capacities: Capacity[] }>(
        `/capacity`,
        body
      )
      return res.data.capacities
    },
    staleTime: 0,
    gcTime: 0,
    enabled: options.capacityGroupIds.length > 0,
  })
}

export default useCapacities
